import {
  API_AGENT_REQUEST_PATH,
  API_E_CARD_PATH,
  API_HOST_NAME,
} from '../env.js';
import {
  GET_REQUEST,
  POST_FORM_DATA_REQUEST,
  POST_REQUEST,
} from '@helpers/request.js';

const E_CARD_ROOT = API_HOST_NAME + API_E_CARD_PATH;
const AGENT_REQUEST_ROOT = API_HOST_NAME + API_AGENT_REQUEST_PATH;

const structurePaths = {
  eCard: {
    getInfo: E_CARD_ROOT + '/get-info',
    getPersonalBusinessInfo: E_CARD_ROOT + '/get-personal-and-business-info',
    getAva: E_CARD_ROOT + '/get-avatar',
    getQrImage: E_CARD_ROOT + '/qr-image',
  },
  agentRequest: {
    validateChangeAva: AGENT_REQUEST_ROOT + '/validate-change-avatar',
    validateChangePersonalInfo:
      AGENT_REQUEST_ROOT + '/validate-form-update-personal-info',
    generateOtpForChangeAva:
      AGENT_REQUEST_ROOT + '/generate-otp-for-change-avatar',
    refreshOtp: AGENT_REQUEST_ROOT + '/refresh-otp',
    validateOtp: AGENT_REQUEST_ROOT + '/validate-otp',
    getRequestNumAva: AGENT_REQUEST_ROOT + '/getRequestNumAvatar',
    getRequestNumNextValue: AGENT_REQUEST_ROOT + '/getRequestNumNextValue',
    getPersonalInfoList: AGENT_REQUEST_ROOT + '/get-agent-request',
    getPersonalInfoDetail: AGENT_REQUEST_ROOT + '/get-agent-request-detail',
    getPaymentPlanList: AGENT_REQUEST_ROOT + '/get-payment-plan',
    checkAgentIsLockChangeInformationValidateBySms:
      AGENT_REQUEST_ROOT +
      '/check-agent-is-lock-change-information-validate-by-sms',
    getAgentBranchInformation:
      AGENT_REQUEST_ROOT + '/get-agent-branch-information',
    getMyProperties: API_HOST_NAME + '/agent/get-my-properties',
  },
  getAccessBarcode: API_HOST_NAME + '/agent/get-access-barcode',
  forceChangePasswordForFirstTimeLogin:
    API_HOST_NAME + '/account/first-time-login',
  changePassword: API_HOST_NAME + '/account/change-password',
};

export const getECardInfoService = ({ personalId }) => {
  return POST_FORM_DATA_REQUEST(structurePaths.eCard.getInfo, { personalId });
};

export const getECardIndividualBusinessService = () => {
  return GET_REQUEST(structurePaths.eCard.getPersonalBusinessInfo, {});
};

export const getECardAvaService = ({ personId }) => {
  return POST_REQUEST(
    structurePaths.eCard.getAva,
    { personId },
    {
      responseType: 'blob',
    },
  );
};

export const getECardQrImageService = () => {
  return GET_REQUEST(
    structurePaths.eCard.getQrImage,
    {},
    {
      responseType: 'blob',
    },
  );
};

export const getAgentRequestChangeAvaService = ({ agentCode, data }) => {
  return POST_FORM_DATA_REQUEST(
    structurePaths.agentRequest.validateChangeAva,
    data,
    { creater: agentCode },
  );
};

export const getAgentRequestGenOtpForChangeAvaService = ({
  agentCode,
  data,
}) => {
  return POST_FORM_DATA_REQUEST(
    structurePaths.agentRequest.generateOtpForChangeAva,
    data,
    { creater: agentCode },
  );
};

export const getRefreshOtpService = ({ agentCode, referenceCode }) => {
  return GET_REQUEST(structurePaths.agentRequest.refreshOtp, {
    creater: agentCode,
    referenceCode,
  });
};

export const getAgentRequestValidateOtpService = ({
  otpValue,
  referenceCode,
  owner,
}) => {
  return POST_REQUEST(structurePaths.agentRequest.validateOtp, {
    otpValue,
    referenceCode,
    owner,
  });
};

export const getAgentRequestNumAvaService = ({
  agentCode,
  referenceCode,
  otpValue,
  referenceAgentRequestTypeId,
  data,
}) => {
  return POST_FORM_DATA_REQUEST(
    structurePaths.agentRequest.getRequestNumAva,
    data,
    {
      creater: agentCode,
      referenceCode,
      otpValue,
      referenceAgentRequestTypeId,
    },
  );
};

export const getAgentRequestPersonalInfoListService = ({
  agentCode,
  page,
  size,
}) => {
  return GET_REQUEST(structurePaths.agentRequest.getPersonalInfoList, {
    creater: agentCode,
    page,
    size,
  });
};

export const getAgentRequestPersonalInfoDetailsService = ({ requestId }) => {
  return GET_REQUEST(structurePaths.agentRequest.getPersonalInfoDetail, {
    requestId,
  });
};

export const getAgentRequestPaymentPlanListService = () => {
  return GET_REQUEST(structurePaths.agentRequest.getPaymentPlanList, {});
};

export const getAgentRequestChangePersonalInfoService = (payload) => {
  return POST_REQUEST(
    structurePaths.agentRequest.validateChangePersonalInfo,
    payload,
  );
};

export const getAgentRequestNumNextValueService = (payload) => {
  return POST_REQUEST(
    structurePaths.agentRequest.getRequestNumNextValue,
    payload,
  );
};

export const getAccessBarcodeService = () => {
  return GET_REQUEST(
    structurePaths.getAccessBarcode,
    {},
    {
      responseType: 'blob',
    },
  );
};

export const forceChangePasswordForFirstTimeLoginService = (data) => {
  return POST_REQUEST(
    structurePaths.forceChangePasswordForFirstTimeLogin,
    data,
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    },
  );
};

export const changePasswordService = (data) => {
  return POST_REQUEST(structurePaths.changePassword, data, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};

export const checkAgentIsLockChangeInformationValidateBySmsService = () =>
  GET_REQUEST(
    structurePaths.agentRequest.checkAgentIsLockChangeInformationValidateBySms,
    {},
  );

export const getAgentBranchInformationService = (agentCode, channelCode) =>
  GET_REQUEST(structurePaths.agentRequest.getAgentBranchInformation, {
    agentCode,
    channelCode,
  });

export const getMyPropertiesService = (page, size) => {
  return GET_REQUEST(structurePaths.agentRequest.getMyProperties, {
    page,
    size,
  });
};
